import { createSelector } from '@reduxjs/toolkit';
import { IState } from 'core';
import { IToastState } from './types';

const toastStateSelector = (state: IState) => state.toastReducer;

export const toastSelector = createSelector(toastStateSelector, (state: IToastState) => ({
  toastItem: state.toastItem,
}));
